import { classNames } from "shared/lib/classNames/classNames";
import { useMemo } from "react";
import style from "./index.module.css";
import PaginationArrowIconRight from "assets/images/icons/arrow-right.svg";
import PaginationArrowIconLeft from "assets/images/icons/arrow-left.svg";
import etc from "assets/images/icons/icon-more-two.svg";
import { returnClassName } from "library/returnClassName";
const Pagination = (props) => {
  const {
    className,
    maxCount,
    currentPage,
    setCurrentPage,
    activeClassName,
    itemsPerPage,
  } = props;

  const paginationList = useMemo(() => {
    const stopNumber = Math.ceil(maxCount / itemsPerPage);
    const res = [];
    if (stopNumber > 5) {
      let j = 0;
      for (let i = 0; i < 3; i++) {
        res.push(i + 1);
      }
      res.push(
        <div className={style.pagination_etc}>
          {" "}
          <img src={etc} />
        </div>
      );
      res.push((j = stopNumber));
    } else {
      for (let i = 0; i < stopNumber; i++) {
        res.push(i + 1);
      }
    }

    return res;
  }, [maxCount, itemsPerPage]);

  return (
    <div className={classNames(style.Pagination, className)}>
      <button
        type="button"
        className={style.pagination_icon}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        <img src={PaginationArrowIconLeft} alt="pagination_arrow" />
      </button>
      {paginationList.map((item) => (
        <button
          key={item}
          type="button"
          className={classNames(style.pagination_item, {
            [activeClassName
              ? returnClassName(activeClassName, style)
              : style.active]: currentPage === item,
          })}
          onClick={() => setCurrentPage(item)}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        className={classNames(style.pagination_icon, style.right)}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        <img src={PaginationArrowIconRight} alt="pagination_arrow" />
      </button>
    </div>
  );
};
export default Pagination;
